// Chakra Imports
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
} from "@chakra-ui/modal";
import { useDisclosure } from "@chakra-ui/hooks";
import React, { useEffect, useState } from "react";
import Light from "assets/img/layout/Light.png";
import Dark from "assets/img/layout/Dark.png";
// import Contrast from "assets/img/layout/Contrast.png";
// import ContrastDark from "assets/img/layout/ContrastDark.png";
// Assets
import { MdSettings, MdRefresh } from "react-icons/md";
import ConfiguratorRadio from "./ConfiguratorRadio";
import { useTranslation } from "react-i18next";
export default function HeaderLinks(props: { [x: string]: any }) {
  const { t } = useTranslation();
  const { theme, setTheme, darkmode, setDarkmode } = props;
  //eslint-disable-next-line
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [active, setActive] = useState("Purple");
  const [contrast, setContrast] = useState(false);
  const btnRef = React.useRef();
  // const [fullscreen, setFullscreen] = useState(false);
  // Chakra Color Mode
  const resetTheme = () => {
    const newTheme = {
      "--shadow-100": "rgba(112, 144, 176, 0.08)",
      "--background-100": "#FFFFFF",
      "--background-900": "#0b1437",
      "--color-50": "#E9E3FF",
      "--color-100": "#C0B8FE",
      "--color-200": "#A195FD",
      "--color-300": "#8171FC",
      "--color-400": "#7551FF",
      "--color-500": "#422AFB",
      "--color-600": "#3311DB",
      "--color-700": "#2111A5",
      "--color-800": "#190793",
      "--color-900": "#11047A",
    };
    setTheme(newTheme);
  };
  const changeThemeGreen = () => {
    const newTheme = {
      "--color-50": "#E1FFF4",
      "--color-100": "#BDFFE7",
      "--color-200": "#7BFECE",
      "--color-300": "#39FEB6",
      "--color-400": "#01F99E",
      "--color-500": "#01B574",
      "--color-600": "#01935D",
      "--color-700": "#016B44",
      "--color-800": "#00472D",
      "--color-900": "#002417",
    };
    setTheme(newTheme);
  };
  const changeThemeOrange = () => {
    const newTheme = {
      "--color-50": "#FFF7EB",
      "--color-100": "#FFF1DB",
      "--color-200": "#FFE2B8",
      "--color-300": "#FFD28F",
      "--color-400": "#FFC46B",
      "--color-500": "#FFB547",
      "--color-600": "#FF9B05",
      "--color-700": "#C27400",
      "--color-800": "#855000",
      "--color-900": "#422800",
      "--color-950": "#1F1200",
    };
    setTheme(newTheme);
  };
  const changeThemeRed = () => {
    const newTheme = {
      "--color-50": "#FCE8E8",
      "--color-100": "#FAD1D1",
      "--color-200": "#F4A4A4",
      "--color-300": "#EF7676",
      "--color-400": "#EA4848",
      "--color-500": "#E31A1A",
      "--color-600": "#B71515",
      "--color-700": "#891010",
      "--color-800": "#5B0B0B",
      "--color-900": "#2E0505",
      "--color-950": "#170303",
    };
    setTheme(newTheme);
  };
  const changeThemeBlue = () => {
    const newTheme = {
      "--color-50": "#EBEFFF",
      "--color-100": "#D6DFFF",
      "--color-200": "#ADBFFF",
      "--color-300": "#8AA3FF",
      "--color-400": "#6183FF",
      "--color-500": "#3965FF",
      "--color-600": "#0036FA",
      "--color-700": "#0029BD",
      "--color-800": "#001B7A",
      "--color-900": "#000D3D",
      "--color-950": "#00071F",
    };
    setTheme(newTheme);
  };
  const changeThemeTeal = () => {
    const newTheme = {
      "--color-50": "#EBFAF8",
      "--color-100": "#D7F4F2",
      "--color-200": "#AAE9E4",
      "--color-300": "#82DED6",
      "--color-400": "#59D4C9",
      "--color-500": "#33C3B7",
      "--color-600": "#299E94",
      "--color-700": "#1F756E",
      "--color-800": "#144D48",
      "--color-900": "#0B2826",
      "--color-950": "#051413",
    };
    setTheme(newTheme);
  };
  const changeThemeBrand = () => {
    const newTheme = {
      "--color-50": "#EFEBFF",
      "--color-100": "#E9E3FF",
      "--color-200": "#422AFB",
      "--color-300": "#422AFB",
      "--color-400": "#7551FF",
      "--color-500": "#422AFB",
      "--color-600": "#3311DB",
      "--color-700": "#02044A",
      "--color-800": "#190793",
      "--color-900": "#11047A",
    };
    setTheme(newTheme);
  };
  const changeBgDefault = () => {
    let newTheme = theme;
    newTheme = {
      "--shadow-100": "rgba(112, 144, 176, 0.08)",
      "--background-100": "#FFFFFF",
      "--background-900": "#0b1437",
    };
    setTheme(newTheme);
  };
  const changeBgContrast = () => {
    let newTheme = theme;
    newTheme = {
      "--shadow-100": "transparent",
      "--background-100": "#F4F7FE",
      "--background-900": "#070f2e",
    };
    setTheme(newTheme);
  };
  useEffect(() => {
    if (theme["--color-500"] === "#01B574") {
      setActive("Green");
    } else if (theme["--color-500"] === "#FFB547") {
      setActive("Orange");
    } else if (theme["--color-500"] === "#E31A1A") {
      setActive("Red");
    } else if (theme["--color-500"] === "#3965FF") {
      setActive("Blue");
    } else if (theme["--color-500"] === "#33C3B7") {
      setActive("Teal");
    } else {
      setActive("Purple");
    }
  }, [theme]);
  useEffect(() => {
    if (theme["--background-100"] === "#FFFFFF") {
      setContrast(false);
    } else {
      setContrast(true);
    }
  }, [theme]);
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Watch for fullscreenchange
  useEffect(() => {
    function onFullscreenChange() {
      setIsFullscreen(Boolean(document.fullscreenElement));
    }

    document.addEventListener("fullscreenchange", onFullscreenChange);

    return () =>
      document.removeEventListener("fullscreenchange", onFullscreenChange);
  }, []);
  return (
    <>
      <button
        ref={btnRef}
        className="h-[18px] min-h-[unset] w-max min-w-[unset] bg-none p-0"
        onClick={onOpen}
      >
        <MdSettings className="h-[18px] w-[18px] text-gray-400 dark:text-white" />
      </button>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === "rtl" ? "left" : "right"}
      >
        <DrawerContent className="my-4 ml-0 mr-4 w-[calc(100vw_-_32px)] max-w-[calc(100vw_-_32px)] rounded-2xl bg-white shadow-[-20px_17px_40px_4px_rgba(112,_144,_176,_0.18)] dark:bg-navy-800 dark:shadow-[-22px_32px_51px_4px_#0B1437] sm:ml-4 md:w-[400px] md:max-w-[400px]">
          <DrawerHeader
            px="28px"
            w={{ base: "100%", md: "400px" }}
            pt="24px"
            pb="0px"
          >
            <div
              className="absolute right-[50px] top-[13px] cursor-pointer"
              onClick={() => {
                resetTheme();
                props.setMini(false);
              }}
            >
              <MdRefresh className="h-[22px] w-[22px] text-gray-900 dark:text-white" />
            </div>
            <DrawerCloseButton className="absolute right-[26px] top-[16px] h-4 w-4 text-gray-900 dark:text-white" />
            <div className="flex items-center">
              <p className="text-xl font-bold text-gray-900 dark:text-white">
                {t("configurator.title")}
              </p>
            </div>
            <div className="my-[30px] h-px w-full bg-gray-200 dark:!bg-navy-700" />
          </DrawerHeader>
          <DrawerBody
            overflowY="scroll"
            px="28px"
            pt="0px"
            pb="24px"
            w={{ base: "100%", md: "400px" }}
            maxW="unset"
          >
            <div className="flex flex-col">
              <p className="mb-3 font-bold text-gray-900 dark:text-white">
                {t("configurator.colorMode")}
              </p>
              <div className="mb-7 flex w-full justify-between gap-5">
                <ConfiguratorRadio
                  onClick={() => {
                    if (darkmode) {
                      document.body.classList.remove("dark");
                      setDarkmode(false);
                    }
                  }}
                  active={
                    document.body.classList.contains("dark") ? false : true
                  }
                  label={
                    <p className="font-bold text-gray-900 dark:text-white">
                      {t("configurator.light")}
                    </p>
                  }
                >
                  <img
                    className="max-w-[130px] rounded-lg"
                    alt=""
                    src={Light}
                  />
                </ConfiguratorRadio>
                <ConfiguratorRadio
                  onClick={() => {
                    if (!darkmode) {
                      document.body.classList.add("dark");
                      setDarkmode(true);
                    }
                  }}
                  active={
                    !document.body.classList.contains("dark") ? false : true
                  }
                  label={
                    <p className="font-bold text-gray-900 dark:text-white">
                      {t("configurator.dark")}
                    </p>
                  }
                >
                  <img className="max-w-[130px] rounded-lg" alt="" src={Dark} />
                </ConfiguratorRadio>
              </div>
            </div>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
